const PREDICT_AND_SCORE_OP_NAME_PRE_PYDANTIC = 'Evaluation-predict_and_score';
export const PREDICT_AND_SCORE_OP_NAME_POST_PYDANTIC =
  'Evaluation.predict_and_score';
const EVALUATE_OP_NAME_PRE_PYDANTIC = 'Evaluation-evaluate';
export const EVALUATE_OP_NAME_POST_PYDANTIC = 'Evaluation.evaluate';
export const PREDICT_OP_NAME = 'Model.predict';

const parseOpNameFromRef = (opNameOrRef: string): string => {
  if (!opNameOrRef.startsWith('weave:///')) {
    return opNameOrRef;
  }

  const opMatch = opNameOrRef.match(/\/op\/([^:]+)/);
  if (opMatch && opMatch[1]) {
    return opMatch[1];
  }

  return opNameOrRef;
};

export const isPredictAndScoreOp = (opName: string) =>
  opName === PREDICT_AND_SCORE_OP_NAME_PRE_PYDANTIC ||
  opName === PREDICT_AND_SCORE_OP_NAME_POST_PYDANTIC;

export const isPredictAndScoreOpRef = (opNameOrRef: string) => {
  const opName = parseOpNameFromRef(opNameOrRef);
  return isPredictAndScoreOp(opName);
};

export const isEvaluateOp = (opName: string) =>
  opName === EVALUATE_OP_NAME_PRE_PYDANTIC ||
  opName === EVALUATE_OP_NAME_POST_PYDANTIC;

export const isEvaluateOpRef = (opNameOrRef: string) => {
  const opName = parseOpNameFromRef(opNameOrRef);
  return isEvaluateOp(opName);
};
